import {css, useTheme} from '@mui/material';
import {DlMuiDynamicIcon, GetStylesFunction} from '@wallaby-ui/core';
import * as React from 'react';

interface OwnProps {
  children: React.ReactNode;
  iconName?: string;
  iconTitle?: string;
  hideBottomBorder?: boolean;
  hideIcon?: boolean;
}

type Props = OwnProps;

export const PatientCardItemWrapper: React.FC<Props> = (props) => {
  const {children, iconName, hideBottomBorder, hideIcon = false, iconTitle, ...restProps} = props;
  const theme = useTheme();
  const styles = getStyles({theme});

  return (
    <div css={styles.wrapper} {...restProps}>
      {hideIcon
        ? null
        : iconName && (
            <DlMuiDynamicIcon
              iconTitle={iconTitle ?? ''}
              iconName={iconName}
              inputCss={styles.icon}
              svgIconInputCss={styles.icon}
              noButtonStyles
            />
          )}
      {children}
      {hideBottomBorder ? null : <div css={styles.divider} />}
    </div>
  );
};

PatientCardItemWrapper.displayName = 'PatientCardItemWrapper';

const getStyles: GetStylesFunction = (options) => ({
  wrapper: css`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  `,
  divider: css`
    width: 100%;
    border-top: 1px solid ${options?.theme?.palette.custom.canvasGray as string};
  `,
  icon: css`
    width: 24px;
    height: 24px;
    color: var(--dlTheme-300);
  `,
});
